
export enum ExternalFileContentActionsTypes {
  SET_INIT = 'external_file/set_init',
  SET_EXTERNAL_FILE_FORM = 'external_file/set_form',
  SET_EXTERNAL_FILE_FORM_KEY_VALUE = 'external_file/set_form_key_value',
  SET_EXTERNAL_FILE_FORM_KEYS_VALUES = 'external_file/set_form_keys_values',

  SET_PREVIEW = 'external_file/set_preview',
  UNSET_PREVIEW = 'external_file/unset_preview'
}

// Interfaces

interface SetInitAction {
  type: ExternalFileContentActionsTypes.SET_INIT;
  payload: boolean;
}

interface SetContentFormAction {
  type: ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM;
  payload: any;
}

interface SetContentFormKeyValueAction {
  type: ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM_KEY_VALUE;
  payload: {
    key: string;
    value: any;
  }
}

interface SetContentFormKeysValuesAction {
  type: ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM_KEYS_VALUES;
  payload: any;
}

interface SetPreviewAction {
  type: ExternalFileContentActionsTypes.SET_PREVIEW;
  payload: any;
}

interface UnsetPreviewAction {
  type: ExternalFileContentActionsTypes.UNSET_PREVIEW;
}

// Functions

export function setInit(init: boolean): SetInitAction {
  return {
    type: ExternalFileContentActionsTypes.SET_INIT,
    payload: init,
  }
}

export function setContentForm(form: any): SetContentFormAction {
  return {
    type: ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM,
    payload: form,
  }
}

export function setContentFormKeyValue(key: string, value: any): SetContentFormKeyValueAction {
  return {
    type: ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM_KEY_VALUE,
    payload: {
      key,
      value,
    }
  }
}

export function setContentFormKeysValues(
  keys: string[],
  values: any[]
): SetContentFormKeysValuesAction {
  const payload = keys.reduce((acc: any, key, index) => {
    acc[key] = values[index];
    return acc;
  }, {});

  return {
    type: ExternalFileContentActionsTypes.SET_EXTERNAL_FILE_FORM_KEYS_VALUES,
    payload: payload,
  }
}

export function setPreview(payload: any): SetPreviewAction {
  return {
    type: ExternalFileContentActionsTypes.SET_PREVIEW,
    payload,
  }
}

export function unsetPreview(): UnsetPreviewAction {
  return {
    type: ExternalFileContentActionsTypes.UNSET_PREVIEW,
  }
}

export type ExternalFileContentActions =
  | SetInitAction
  | SetContentFormAction
  | SetContentFormKeyValueAction
  | SetContentFormKeysValuesAction
  | SetPreviewAction
  | UnsetPreviewAction;
